import { z } from "zod";
import { kePhone, futureDateIso } from "./common.js";
export const ageBand = z.enum(["21-30", "31-40", "41-50", "51-60"]);
export const benefitSharing = z.enum(["SHARED", "PER_PERSON"]);
/** Families by member count, M through M+5. Plus extras for families with >5. */
export const categoryPopulation = z.object({
    M: z.number().int().min(0).default(0),
    Mplus1: z.number().int().min(0).default(0),
    Mplus2: z.number().int().min(0).default(0),
    Mplus3: z.number().int().min(0).default(0),
    Mplus4: z.number().int().min(0).default(0),
    Mplus5: z.number().int().min(0).default(0),
    additionalDependents: z.number().int().min(0).default(0),
});
export const categoryBenefitSharing = z.object({
    inpatient: benefitSharing.default("SHARED"),
    outpatient: benefitSharing.default("SHARED"),
    /** Per spec: Dental, Optical, Last Expense are always PER PERSON. */
    dental: z.literal("PER_PERSON").default("PER_PERSON"),
    optical: z.literal("PER_PERSON").default("PER_PERSON"),
    lastExpense: z.literal("PER_PERSON").default("PER_PERSON"),
    /** Per spec: Maternity is always PER FAMILY. */
    maternity: z.literal("PER_FAMILY").default("PER_FAMILY"),
    /** Per spec: PA is always PER PERSON (principal + spouse). */
    personalAccident: z.literal("PER_PERSON").default("PER_PERSON"),
});
export const categoryLimits = z.object({
    inpatientKes: z.number().int().min(0),
    outpatientKes: z.number().int().min(0),
    dentalKes: z.number().int().min(0),
    opticalKes: z.number().int().min(0),
    maternityKes: z.number().int().min(0),
    lastExpenseKes: z.number().int().min(0),
    criticalIllnessKes: z.number().int().min(0),
    personalAccidentKes: z.number().int().min(0),
    numberWithSpouses: z.number().int().min(0),
});
export const jobCategory = z.object({
    id: z.enum(["A", "B", "C", "D", "E", "F"]),
    population: categoryPopulation,
    sharing: categoryBenefitSharing,
    limits: categoryLimits,
});
export const groupMedicalPayloadSchema = z.object({
    proposer: z.object({
        icpakMemberNumber: z.string().min(1),
        fullName: z.string().min(1),
        firmName: z.string().min(1),
        phone: kePhone,
        email: z.string().email(),
    }),
    criticalIllnessExtension: z.boolean().default(false),
    averageAgeBand: ageBand.optional(),
    groupPersonalAccidentExtension: z.boolean().default(false),
    coverStartDate: futureDateIso,
    categories: z.array(jobCategory).min(1).max(6),
    coverBenefitManagement: z.enum(["SMART", "MANUAL"]).default("SMART"),
    alreadyOnSmart: z.boolean().default(false),
    coPayments: z.boolean().default(false),
});
/** Tailor-made request (>19 employees). Identity/contact only. */
export const groupMedicalTailorMadePayloadSchema = z.object({
    proposer: groupMedicalPayloadSchema.shape.proposer,
    estimatedEmployees: z.number().int().min(20).optional(),
    notes: z.string().max(2000).optional(),
});
